import { useNavigate } from 'react-router-dom';
import { useQueryParameters } from 'utils/hooks/useQueryParameters';

export const useWorkspaceInvitationSearchParams = () => {
  const params = useQueryParameters();
  const navigate = useNavigate();

  const { inviteId = '', workspaceId = '', code = '' } = Object.fromEntries(params.entries());

  if (!(inviteId.length > 0) || !(workspaceId.length > 0) || !(code.length > 0)) {
    navigate('/');
    return {
      inviteId: '',
      workspaceId: '',
      confirmationCode: '',
    };
  }

  return {
    inviteId,
    workspaceId,
    confirmationCode: code,
  };
};
